import { FC } from 'react'
import { HeaderIcon } from './types'
import { HeaderIconPathStyles, HeaderIconSVGStyles } from './constant'

const LeaderBoardIcon: FC<HeaderIcon> = ({ iconType }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={HeaderIconSVGStyles[iconType]}
    >
      <path
        style={iconType === 'active' ? {} : HeaderIconPathStyles}
        d="M7 1C6.30964 1 5.75 1.55964 5.75 2.25V13.75C5.75 14.4404 6.30964 15 7 15H9C9.69036 15 10.25 14.4404 10.25 13.75V2.25C10.25 1.55964 9.69036 1 9 1H7ZM9 2H7C6.86193 2 6.75 2.11193 6.75 2.25V13.75C6.75 13.8881 6.86193 14 7 14H9C9.13807 14 9.25 13.8881 9.25 13.75V2.25C9.25 2.11193 9.13807 2 9 2Z"
      />
      <path
        style={iconType === 'active' ? {} : HeaderIconPathStyles}
        d="M1.25 8C0.559644 8 0 8.55964 0 9.25V13.75C0 14.4404 0.559644 15 1.25 15H3.25C3.94036 15 4.5 14.4404 4.5 13.75V9.25C4.5 8.55964 3.94036 8 3.25 8H1.25ZM3.25 9H1.25C1.11193 9 1 9.11193 1 9.25V13.75C1 13.8881 1.11193 14 1.25 14H3.25C3.38807 14 3.5 13.8881 3.5 13.75V9.25C3.5 9.11193 3.38807 9 3.25 9Z"
      />
      <path
        style={iconType === 'active' ? {} : HeaderIconPathStyles}
        d="M11.5 5.25C11.5 4.55964 12.0596 4 12.75 4H14.75C15.4404 4 16 4.55964 16 5.25V13.75C16 14.4404 15.4404 15 14.75 15H12.75C12.0596 15 11.5 14.4404 11.5 13.75V5.25ZM12.75 5H14.75C14.8881 5 15 5.11193 15 5.25V13.75C15 13.8881 14.8881 14 14.75 14H12.75C12.6119 14 12.5 13.8881 12.5 13.75V5.25C12.5 5.11193 12.6119 5 12.75 5Z"
      />
    </svg>
  )
}

export default LeaderBoardIcon
